import { PayloadEpic } from '@/store/epics/epic-types';
import { catchError, filter, switchMap } from 'rxjs/operators';
import { actions, asyncActions } from '@/store/slices';
import { concat, EMPTY, from, of } from 'rxjs';
import { objectToUrlSearchParams } from '@/utils/url-search-params-utils';
import axios from 'axios-observable';
import { apiEndpoints } from '@/store/constants';
import { PublicInvoiceModel } from '@/models';
import { FetchPublicInvoicesPayload } from '@/store/slices/payload-types/FetchPublicInvoicesPayload';

export const fetchPublicInvoicesEpic: PayloadEpic<FetchPublicInvoicesPayload, PublicInvoiceModel[]> = (action$) => {
    return action$.pipe(
        filter(asyncActions.publicInvoices.fetchAll.match),
        switchMap(({ payload }) => concat(
            of(actions.publicInvoices.setIsLoadingPublicInvoices(true)),
            of(actions.publicInvoices.setTotalCount(0)),
            fetchPublicInvoices(payload).pipe(
                switchMap(({ data }) => from([
                    actions.publicInvoices.setAll(data.results),
                    actions.publicInvoices.setTotalCount(data.count),
                ])),
                catchError((error) => {
                    console.error('fetchPublicInvoicesEpic', error);

                    return EMPTY;
                }),
            ),
            of(actions.publicInvoices.setIsLoadingPublicInvoices(false)),
        )),
    );
};

const fetchPublicInvoices = (payload: FetchPublicInvoicesPayload) => {
    const searchParams = objectToUrlSearchParams(payload);

    return axios.get<ListResponse<PublicInvoiceModel>>(`${apiEndpoints.publicInvoices()}?${searchParams}`);
};
